// src/utils/cryptoService.js
import CryptoJS from "crypto-js";

const SECRET_KEY = process.env.VUE_APP_API_SECRETKEY;

function validateKey() {
  if (!SECRET_KEY || SECRET_KEY.length !== 32) {
    return false
  }

  return CryptoJS.enc.Utf8.parse(SECRET_KEY);
}

export function encryptText(value) {
  if (!value) return null;

  const key = validateKey();

  const iv = CryptoJS.lib.WordArray.random(16);

  const encrypted = CryptoJS.AES.encrypt(
    value,
    key,
    {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );

  const encryptedData = iv
    .concat(encrypted.ciphertext)
    .toString(CryptoJS.enc.Base64);

  return encryptedData;
}

export function encryptPassword(password) {
  return encryptText(password);
}